import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { DBOccupation } from '../../models/stack9/Occupation';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

const S9Button = ui.S9Button.default;
const { useRefreshList, Space } = ui;

export const config: S9ComponentConfig = {
  name: 'OccupationDrawerAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type OccupationDrawerActionProps = {
  row: Partial<DBOccupation>;
};

const OccupationDrawerAction = ({ row }: OccupationDrawerActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  const formFields = [
    { field: 'code' },
    { field: 'name' },
    { field: 'is_active' },
    { field: 'lang_set' },
  ];
  return (
    <>
      {row.id ? (
        <S9Button
          type="link"
          style={{ width: '100%', textAlign: 'left' }}
          onClick={() => setIsOpen(true)}
          label={`${row.code}`}
        />
      ) : (
        <Space>
          <S9Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      )}
      <EntityDrawer
        title="occupation"
        id={row?.id}
        open={isOpen}
        formFields={formFields}
        initialValues={row}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
        screenQueryName={EDetailsQueryNames.GetOccupationDetails}
        entityName={entityNames.OCCUPATION}
        editRoute={AppRoutes.CountrySetupDetail}
        relativePath={AppRoutes.CountrySetupDetail}
      />
    </>
  );
};

export default OccupationDrawerAction;
